import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'БЕЛАВЕЖСКАЯ ПУШЧА. Наша Нива. 1908 г. Вильня';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>

                    <img src={require('./../img/topics/NashaNiwaBelPuscha1908/nashaniwabelpuscha1908.jpg')}/>

                    <p>Белавежская Пушча ляжыцъ у самай сярэдзине Гродзенскай губэрни (ў палудзеннай часьци Волкавыскаго
                        и заходней Пружанскаго павету). Яна мае ў сабе 121 тысячу дзесяцин лесу.</p>
                    <p>Даўнейшые жыцели Пушчы, литвины, кались думали, што тамака жывуць розные баги и бажэнята, ў
                        каторых яны верыли; дык надта яе шанавали. Литвины з малых дзён прывучалися тутака змагацца з
                        дзикими зьверами, каторых кались было многа, и гэтак падгатаўлялися да вайны з сваими ворагами.
                        Паляваньне тутака было цэлым сьвятам для литвиноў. Их князи—Гедымин, Ягелло, Витовт, — пасьля
                        выгранай вайны с чужынцами, трымаючыся звычаю, заўсягды езьдзили ў Пушчу паляваць. Вось и любили
                        яе моцна, ды нават завяли асобнае упраўленьне ёю, на каторае грошы даваў народ—па 4 грошыки з
                        душы.</p>
                    <p>С часам Пушча разам з усей Литвой прылучылася да Польшчы, и яе тады крыху урэзали. Пазьней, як
                        Расея забрала Польшчу, Пушча перайшла на ўласнасць Царскай Сямьи. Пры гэтым добрую часьцину яе
                        изноў раздали розным генэралом, а часць вырубили. Але ўжо Александэр I забараниў яе рубаць, а
                        цяперашни Гасудар прызнаў, што трэба рупицца толъки аб тое, каб Пушча аставалася такая, як была
                        ад векоў, а аб даход дбаць нима што. С таго часу Пушча служыць для паляваньня Царскай Сямьи. У
                        апошние годы с Пушчы прадавали па крысе сухастою, дый гэты даход штогод зменшаўся ад 200 тыс,
                        руб. да 65 тыс. 407 руб. Апроч гэтаго Пушча дае даход за пашу быдла пушчанских мужыкоў, што
                        жывуць па вёсках, раскинутых па ўсей Пушчы. Яны плацили ўсяго 7—6 тыс. руб. у год.</p>
                    <p>У Пушчы недаўна збудавали новы палац, гдзе затрымываюцца Цары, як едуць паляваць. Да паляваньня и
                        каб пилнаваць зьвероў, у Пушчы заведзена многа лясьникоў, стрэльцоў, старажоў лясных и т. д.</p>
                    <p>Найбольш каштуе корм зьвероў. У Пушчы захавалися ешчэ такие зьверы, што близка нигдзе их нима:
                        гэта — зубры, рысунак каторых быў ужо ў «Н. Н.» (№ 4 — 1908 г.)—И тутака яны памалу выводзяцца,
                        дык вось, каб яны саўсим ня згинули, да их прыставили асобных старажоў и даюцъ корм, каторы им
                        патробеy да жыцьця. Гэты корм зуброў и других зьвероў, што там жывуць для Царскаго паляваньня,
                        каштуе каля 40 тысяч руб. у год. Таким парадкам, як пиша «Лесной Журналъ», с Пушчы даходу нима,
                        и нават прыходзицца дакладаць кожны год.</p>
                    <p>Апроч адвечных жыцелёў Пушчы —зуброў и иншых зьвероў, асталося тут немала вельми старых дзярэў,
                        каторые помняць можэ ешчэ князёў литоўских. На нашым рысунку бачым такую старую липу, што ў
                        дупле яе можа схавацца некольки чалавек.</p>
                    <p>Е. П. Наша Нива. Першая Беларуская Газэта з рысунками. 20(3) наябра 1908 г. Вильня</p>
                </div>
            </div>
        </>
    );
}